/**
 * FEAT-108 / S-437 — the workspace list a settings screen's picker offers.
 *
 * Same request and cache key every settings screen already used
 * (GET /agencyclients, the full rows the screens need), narrowed for anyone
 * but an Admin to the workspaces they are a member of — the list the desk
 * switcher already shows (workspace-context, GET /agencyclients/me). A
 * Reviewer or Editor is never offered a workspace they cannot open.
 */
import { useMemo } from "react";
import { useApiQuery } from "./api";
import { useRole } from "./useRole";
import { useWorkspaceContext } from "./workspace-context";
import { visibleWorkspaces } from "./roles";

export function useSettingsWorkspaces<T extends { id: number }>() {
  const { role } = useRole();
  const all = useApiQuery<T[]>(["agencyclients"], "/agencyclients");
  const mine = useWorkspaceContext();

  const data = useMemo(() => {
    if (!all.data) return undefined;
    return visibleWorkspaces(all.data, new Set(mine.workspaces.map((w) => w.id)), role);
  }, [all.data, mine.workspaces, role]);

  return {
    data,
    isLoading: all.isLoading || mine.isLoading,
    error: all.error ?? mine.error,
  };
}
